import getVehicleDataPush from "../utils/getVehicledataPush";
import { Items as VehicleInformation } from "../vehicle-search-details/vehicleSearch.type";

interface BatterySlideoutDataPushPropTypes {
  mechReportCombo: string;
  isTracked: boolean;
  note: string;
  catalogueRef: string | string[];
  linkType: "report" | "more-info" | "terms-conditions";
  type?: string;
  vehicleInfo?: VehicleInformation;
}

export const batterySlideoutDataPush = ({
  mechReportCombo,
  isTracked,
  note,
  linkType,
  type = "",
  catalogueRef,
  vehicleInfo,
}: BatterySlideoutDataPushPropTypes) => {
  //@ts-ignore
  if (window.digitalData) {
    let vehicleDataPush;

    vehicleDataPush = getVehicleDataPush(
      vehicleInfo,
      catalogueRef,
      isTracked,
      note,
      mechReportCombo
    );

    let result: {
      event;
      product;
    } = {
      event: {
        name: "click",
        category: linkType === "more-info" ? "link" : "button",
        label: `ev-battery|${linkType}`,
        action: linkType === "report" ? "view" : "navigate",
        section: "pop-up",
        type,
        value: "",
      },
      product: {
        ...vehicleDataPush,
      },
    };

    //@ts-ignore
    return digitalData.push(result);
  }
};
